// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateNewTransferNewDealer = dealer => ({
    dealer,
    type: actions.UPDATE_NEW_TRANSFER_NEW_DEALER
});




// WEBPACK FOOTER //
// ./src/product/new-transfer/action-creators/update-new-dealer.js